import { useEffect } from 'react';

import { Page } from '@typings/page';

export const PARSE_SCRIPT_REGEX =
  /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;

export const usePageScripts = (page?: Page) => {
  useEffect(() => {
    if (!(page && page.gjs && page.gjs['gjs-html'])) return;
    const scripts = page.gjs['gjs-html'].match(PARSE_SCRIPT_REGEX) || [];

    // create tmp div that helps to parse attrs, etc.
    const tmpElement = document.createElement('div');
    tmpElement.innerHTML = scripts.join('');

    // iterate over tmp nodes and create same new nodes to body
    const scriptElements: HTMLScriptElement[] = [];
    Array.from(tmpElement.childNodes).forEach((node) => {
      const element = document.createElement('script');
      // copy content
      element.appendChild(document.createTextNode(node.textContent || ''));

      // copy attributes
      const attributes: NamedNodeMap | undefined = (node as any).attributes;
      if (!attributes) return;
      for (let i = 0; i < attributes.length; i += 1) {
        const { name, value } = attributes[i];
        element.setAttribute(name, value);
      }

      // append to body
      scriptElements.push(document.body.appendChild(element));
    });
    if (typeof tmpElement.remove !== 'undefined') tmpElement.remove();

    // ensure elements removed from dom after unmount
    return () => scriptElements.forEach((el) => document.body.removeChild(el));
  }, [page]);
};
